import Image from 'next/image'

interface LogoProps {
  className?: string
  onClick?: () => void
  src: string
  slug: string
  domain: string
  height: number
}

const Logo = ({ className, onClick, src, slug, domain, height }: LogoProps) => {
  return (
    <div
      role="button"
      onClick={onClick}
      onKeyUp={onClick}
      tabIndex={0}
      className={`logo ${className}`}
      itemScope
      itemType="https://schema.org/Organization"
      aria-labelledby={slug}
    >
      <meta itemProp="url" content={domain} />
      <Image
        data-chromatic="ignore"
        itemProp="logo"
        className="logo__img"
        src={src}
        alt={`${slug}`}
        width={200}
        height={height}
        style={{ width: '100%', objectFit: 'contain' }}
      />
    </div>
  )
}

export default Logo
